<header class="header">
  <nav #header class="navbar fixed-top p-0 background-black">
    <gcc-urgent-alerts [hidden]="!isShowNotifications"></gcc-urgent-alerts>
    <div class="container-fluid" [ngClass]="isMobile ? 'px-3' : 'px-4'">
      <div class="mobile_header_menu">
        <gcc-mobile-user-info
          [gccTrackClick]="applicationArea['Header.Profile']"
          class="btn-icon"
          [user]="user$ | async"
          (logout)="onLogout()"
        >
        </gcc-mobile-user-info>
      </div>
      <div class="navbar-header">
        <span class="navbar-brand">
          <a
            class="logo d-inline-block mr-4 pr-4"
            [gccTrackClick]="applicationArea['Header.Logo']"
            (click)="checkGrantedForNonMemberFirmUser()"
            [routerLink]="['/']"
          >
            <img src="/assets/images/logo.svg" alt="Deloitte" />
          </a>
          <!-- TODO: investigate how to translate 'header.title' in case of login failure -->
          <span class="h6 mb-0 bold">SolveIt {{ view === 'admin' ? ('common.admin' | translate) : '' }}</span>
        </span>
      </div>
      <div
        *ngIf="user$ | async as user"
        class="d-flex align-items-center flex-grow-1"
        [ngClass]="{ 'justify-content-end': isMobile }"
      >
        <ul class="nav semibold flex-grow-1 hidden-container-for-mobile">
          <li *ngFor="let item of navItems" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: item.exact }">
            <a class="d-block" [routerLink]="[item.path]">{{ item.title }}</a>
          </li>
          <li *ngIf="view === 'portal' && user.isAdmin">
            <a class="d-block" [routerLink]="['admin']">{{ 'common.admin' | translate }}</a>
          </li>
        </ul>
        <ul class="nav nav-right">
          <ng-container *ngIf="view === 'portal'">
            <li class="d-flex align-items-center hidden-container-for-mobile">
              <a class="btn btn-icon btn-search">
                <i
                  class="icon icon-info-circle icon-28"
                  [gccTrackClick]="applicationArea['Header.Info']"
                  [routerLink]="['/about']"
                  [tooltip]="'home.about' | translate"
                  [delay]="1000"
                ></i>
              </a>
            </li>
            <li class="d-flex align-items-center">
              <gcc-country-dropdown [gccTrackClick]="applicationArea['Header.Countries']" class="btn-icon">
              </gcc-country-dropdown>
            </li>
            <li class="d-flex align-items-center hidden-container-for-mobile">
              <a
                class="btn btn-icon btn-search"
                [gccTrackClick]="applicationArea['Header.Search']"
                [routerLink]="['/search']"
              >
                <i class="icon icon-search-circle icon-28"></i>
              </a>
            </li>
            <li class="d-flex align-items-center">
              <gcc-notifications-center [gccTrackClick]="applicationArea['Header.Notification']">
              </gcc-notifications-center>
            </li>
          </ng-container>
          <li class="d-flex align-items-center hidden-container-for-mobile">
            <gcc-user-info
              [gccTrackClick]="applicationArea['Header.Profile']"
              class="btn-icon"
              [user]="user"
              (logout)="onLogout()"
            >
            </gcc-user-info>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
